<template>
  <div class="max-w-screen-2xl mx-auto px-4 flex relative flex-wrap w-full py-8 border-b-2 border-[#4C535966]">
    <div class="w-full">
      <h2 class="font-secondary text-2xl md:text-3xl mb-8">{{ tr('Contact') }}</h2>
    </div>
    <div class="w-full grid md:grid-cols-4 sm:grid-cols-2 grid-cols-1 gap-4 items-end">
      <div v-for="field in fields" :key="field.key" class="mb-5">
        <label class="block mb-2 text-sm font-medium text-gray uppercase">
          {{ tr(field.label) }}<span v-if="field.required" class="ml-2 text-primary">*</span>
        </label>
        <div v-if="disabled" class="readonly-field bg-light-gray border border-[#ADAEAE] text-gray text-sm rounded-lg block w-full p-3">****</div>
        <select
          v-else-if="field.key === 'nationality'"
          id="countries"
          :value="modelValue.nationality"
          :class="{ error: errors.nationality }"
          :disabled="disabled"
          class="bg-light-gray border border-[#ADAEAE] text-gray text-sm rounded-lg focus:border-[#ADAEAE] focus:ring-transparent outline-none block w-full p-3"
          @change="updateField('nationality', $event.target.value)"
        >
          <option v-for="(country, index) of countries" :key="index" :value="country.alpha2">
            {{ country.name }}
          </option>
        </select>
        <input
          v-else
          :type="field.type || 'text'"
          :value="modelValue[field.key]"
          :class="{ error: errors[field.key] }"
          :disabled="disabled"
          :readonly="disabled"
          class="bg-light-gray border border-[#ADAEAE] text-gray text-sm rounded-lg focus:border-[#ADAEAE] focus:ring-transparent outline-none block w-full p-3"
          @input="updateField(field.key, $event.target.value)"
        />
      </div>
      <div class="mb-5 sm:col-span-2">
        <p class="text-primary text-sm">{{ tr('Y_WILL_') }}</p>
      </div>
    </div>
  </div>
</template>

<script>
export default {
  name: 'BookingFormContact',
  props: {
    modelValue: { type: Object, required: true },
    errors: { type: Object, required: true },
    disabled: Boolean,
    countries: { type: Array, required: true }
  },
  emits: ['update:modelValue'],
  data () {
    return {
      fields: [
        { key: 'name', label: 'Reservation Name', required: true },
        { key: 'address', label: 'Address', required: true },
        { key: 'zipcode', label: 'ZIP CODE', required: true },
        { key: 'nationality', label: 'Nationality', required: true },
        { key: 'mobile', label: 'Cellphone' },
        { key: 'email', label: 'Email', type: 'email', required: true }
      ]
    };
  },
  methods: {
    updateField (key, value) {
      this.$emit('update:modelValue', { ...this.modelValue, [key]: value });
    },
    tr (key) {
      return this.$root.tr(key);
    }
  }
};
</script>

<style scoped>
.error {
  border: 2px solid red;
}

.readonly-field {
  background-color: #f5f5f5;
  color: #666;
  cursor: not-allowed;
  opacity: 0.8;
}
</style>
